var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "avue-contail",
      class: { "avue--collapse": _vm.isCollapse },
    },
    [
      _c("div", { staticClass: "avue-header" }, [_c("top", { ref: "top" })], 1),
      _c("div", { staticClass: "avue-layout" }, [
        _c("div", { staticClass: "avue-left" }, [_c("sidebar")], 1),
        _c(
          "div",
          { staticClass: "avue-main" },
          [
            _c("tags"),
            _c(
              "transition",
              { attrs: { name: "fade-scale" } },
              [
                _c("search", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isSearch,
                      expression: "isSearch",
                    },
                  ],
                  staticClass: "avue-view",
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isSearch,
                    expression: "!isSearch",
                  },
                ],
                staticStyle: {
                  height: "100%",
                  "overflow-y": "auto",
                  "overflow-x": "hidden",
                  padding: "10px 0 0",
                },
                attrs: { id: "avue-view" },
              },
              [
                _vm.$route.meta.$noKeepAlive
                  ? _c("router-view", {
                      key: _vm.$route.path + _vm.$route.query.id,
                      staticClass: "avue-view",
                    })
                  : _c(
                      "keep-alive",
                      [
                        _c("router-view", {
                          key: _vm.$route.path + _vm.$route.query.id,
                          staticClass: "avue-view",
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "avue-shade", on: { click: _vm.showCollapse } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }